enum EPortalMode {
  GLOBAL_TO_RUSSIA = 'globalToRussia',
  GLOBAL_TO_GLOBAL = 'globalToGlobal',
  RUSSIA_TO_RUSSIA = 'russiaToRussia',
  RUSSIA_TO_GLOBAL = 'russiaToGlobal',
  ALL = 'all',
}

export default EPortalMode;
